import React, { useState, useEffect } from "react";
import api from "../common/api";
import { formatBytes, convertTimestamp, changeModal, clear } from "../common/utils";
import Modal from 'react-modal';
import toast from "react-hot-toast";
import Tips from "../common/tips";
import Switch from 'react-switch';

import ChangeEmail from './func/ChangeEmail'; // 修改邮箱
import Recharge from './func/Recharge'; // 引入充值组件
import Sign from './func/Sign'; // 引入签到组件
import Recom from './func/Recom'; // 引入邀请组件
import Passwd from "./func/Passwd"; // 引入修改密码组件
import PlanDetail from "./func/PlanDetail";
import RegTips from "./func/Tips";
import Sub from "./func/Sub";
import ChangeSub from "./func/ChangeSub";
import RePlan from "./func/rePlan";
import Profile from "./func/Profile";

function Dashboard() {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  const [userInfo, setUserInfo] = useState({});
  const [subLink, setSubLink] = useState({});
  const [nodeList, setNodeList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isAutoRenewEnabled, setIsAutoRenewEnabled] = useState(userInfo.autoRenew);

  // 添加全局点击事件监听
  useEffect(() => {
    const handleClickOutside = (event) => {
      const menu = document.getElementById('profileMenu');
      const button = event.target.closest('button');
      if (menu && !menu.contains(event.target) && !button?.textContent?.includes('修改资料')) {
        menu.classList.add('hidden');
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handleAutoRenewChange = async (checked) => {
    toast.promise(
      api("post", "/api/user/renew", null),
      {
        loading: "正在设置自动续费...",
        success: (response) => {
          if (response.status) {
            setIsAutoRenewEnabled(checked);
            // 更新本地缓存
            const storedUserInfo = JSON.parse(localStorage.getItem('userInfo'));
            storedUserInfo.renew = checked ? 1 : 0;
            localStorage.setItem('userInfo', JSON.stringify(storedUserInfo));
            return "设置成功";
          } else {
            throw new Error(response.message || "设置失败");
          }
        },
        error: (error) => {
          return error.message || "设置失败";
        }
      }
    );
  };

  const getUserInfo = () => {
    setIsLoading(true);
    toast.promise(
      api("post", "/api/user/info", null),
      {
        loading: "正在加载会员信息",
        success: (response) => {
          if (response.status) {
            localStorage.setItem('userInfo', JSON.stringify(response.data));
            localStorage.setItem('userInfo_expire', Date.now() + 60000);
            setUserInfo(response.data);
            setSubLink(process.env.REACT_APP_LINK + `/sub?token=${response.data.token}&uuid=${response.data.uuid}`);
            setIsAutoRenewEnabled(response.data.renew === 1);
            getNodes();
            setIsLoading(false);
            return "加载成功";
          } else {
            if (response.message === "401") {
              clear();
              window.location.href = '/login';
              throw new Error("请重新登录");
            } else {
              throw new Error(response.message);
            }
          }
        },
        error: (error) => {
          setIsLoading(false);
          return error.message;
        }
      }
    );
  };

  const getNodes = async () => {
    if (localStorage.getItem('node') === null || localStorage.getItem('node_expire') < Date.now()) {
      try {
        const response = await api("get", "/api/user/node", null);
        setNodeList(response.data);
        localStorage.setItem('node', JSON.stringify(response.data));
        localStorage.setItem('node_expire', Date.now() + 7200000);
      } catch (error) {
        console.error(error);
      }
    } else {
      setNodeList(JSON.parse(localStorage.getItem('node')));
    }
  };
  useEffect(() => {
    if (localStorage.getItem("register")) {
      const tipsCheckbox = document.getElementById('tips');
      if (tipsCheckbox) {
        tipsCheckbox.checked = true;
      }
    }
    if (params.get('do') === 'charge') {
      changeModal('recharge', true);
    }
    if (params.get('do') === 'sub') {
      changeModal('sub', true);
    }
    if (localStorage.getItem('userInfo') && localStorage.getItem('userInfo_expire') > Date.now()) {
      const storedUserInfo = JSON.parse(localStorage.getItem('userInfo'));
      setUserInfo(storedUserInfo);
      setIsAutoRenewEnabled(storedUserInfo.renew === 1);
      setSubLink(process.env.REACT_APP_LINK + `/sub?token=${storedUserInfo.token}`);
      getNodes();
      setIsLoading(false);
    } else {
      getUserInfo();
    }
  }, []);

  Modal.setAppElement('#root')
  return (
    <>
      {process.env.REACT_APP_TG_GROUP && (
        <Tips msg="加入TG群吹水领福利" title="加入群聊" link={`https://t.me/${process.env.REACT_APP_TG_GROUP}`} />
      )}
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 sm:p-8">
        <div className="max-w-6xl mx-auto space-y-6">
          {/* 用户信息卡片 */}
          <div className="bg-white rounded-2xl shadow-lg p-6 transform transition-all duration-300 hover:shadow-xl">
            {isLoading ? (
              <div className="animate-pulse">
                <div className="flex flex-col sm:flex-row justify-between items-center mb-6">
                  <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-gray-200 rounded-full"></div>
                    <div>
                      <div className="h-6 w-32 bg-gray-200 rounded"></div>
                      <div className="h-4 w-24 bg-gray-200 rounded mt-2"></div>
                    </div>
                  </div>
                  <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-3 mt-4 sm:mt-0 w-full sm:w-auto">
                    <div className="h-10 w-32 bg-gray-200 rounded-full"></div>
                    <div className="h-10 w-32 bg-gray-200 rounded-full"></div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="flex flex-row justify-between items-center mb-6">
                <div className="flex items-center space-x-4 flex-1 min-w-0">
                  <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full flex items-center justify-center text-white text-2xl font-bold flex-shrink-0">
                    {userInfo.username?.charAt(0).toUpperCase()}
                  </div>
                  <div className="block sm:hidden min-w-0">
                    <h1 className="text-lg font-bold text-gray-900 truncate">{userInfo.username}</h1>
                  </div>
                  <div className="hidden sm:block">
                    <h1 className="text-2xl font-bold text-gray-900">{userInfo.username}</h1>
                    <p className="text-gray-500">欢迎回来</p>
                  </div>
                </div>
                <div className="flex flex-col space-y-3 sm:flex-row sm:space-y-0 sm:space-x-3 flex-shrink-0">
                  <button className="bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-6 py-2 rounded-full hover:from-blue-600 hover:to-indigo-700 transition-all duration-300 w-[120px] border-0">
                    <label htmlFor="sign" className="cursor-pointer w-full block text-center">每日签到</label>
                  </button>
                  <button
                    onClick={() => {
                      const modal = document.getElementById('profileModal');
                      const modalContent = document.getElementById('profileModalContent');
                      if (modal && modalContent) {
                        modal.style.display = 'flex';
                        requestAnimationFrame(() => {
                          modal.classList.remove('opacity-0', 'pointer-events-none');
                          modalContent.classList.remove('scale-95', 'opacity-0');
                        });
                      }
                    }}
                    className="bg-gray-100 text-gray-700 px-6 py-2 rounded-full hover:bg-gray-200 transition-all duration-300 w-[120px]"
                  >
                    修改资料
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* 统计卡片 */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {isLoading ? (
              <>
                <div className="bg-white rounded-2xl shadow-lg p-6 animate-pulse">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-3">
                      <div className="w-12 h-12 bg-gray-200 rounded-full"></div>
                      <div className="h-6 w-24 bg-gray-200 rounded"></div>
                    </div>
                    <div className="h-8 w-16 bg-gray-200 rounded-full"></div>
                  </div>
                  <div className="h-8 w-32 bg-gray-200 rounded"></div>
                </div>
                <div className="bg-white rounded-2xl shadow-lg p-6 animate-pulse">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-3">
                      <div className="w-12 h-12 bg-gray-200 rounded-full"></div>
                      <div className="h-6 w-24 bg-gray-200 rounded"></div>
                    </div>
                    <div className="h-8 w-16 bg-gray-200 rounded-full"></div>
                  </div>
                  <div className="h-8 w-32 bg-gray-200 rounded"></div>
                </div>
              </>
            ) : (
              <>
                <div className="bg-white rounded-2xl shadow-lg p-6 transform transition-all duration-300 hover:shadow-xl">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-3">
                      <div className="p-3 bg-blue-100 rounded-full">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      </div>
                      <h3 className="text-lg font-semibold text-gray-900">账户余额</h3>
                    </div>
                    <label htmlFor="recharge" className="btn btn-sm bg-blue-500 hover:bg-blue-600 text-white rounded-full px-4 py-1 transition-all duration-300 whitespace-nowrap border-0">
                      充值
                    </label>
                  </div>
                  <div className="text-3xl font-bold text-gray-900 mb-2">
                    {userInfo.credit ? Math.floor(userInfo.credit) : 0} 元
                  </div>
                </div>

                <div className="bg-white rounded-2xl shadow-lg p-6 transform transition-all duration-300 hover:shadow-xl">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-3">
                      <div className="p-3 bg-green-100 rounded-full">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                        </svg>
                      </div>
                      <h3 className="text-lg font-semibold text-gray-900">奖励余额</h3>
                    </div>
                    <label htmlFor="recom" className="btn btn-sm bg-green-500 hover:bg-green-600 text-white rounded-full px-4 py-1 transition-all duration-300 whitespace-nowrap border-0">
                      邀请好友
                    </label>
                  </div>
                  <div className="text-3xl font-bold text-gray-900 mb-2">
                    {userInfo.aff ? Math.floor(userInfo.aff) : 0} 元
                  </div>
                </div>
              </>
            )}
          </div>

          {/* 订阅信息卡片 */}
          <div className="bg-white rounded-2xl shadow-lg p-6 transform transition-all duration-300 hover:shadow-xl">
            <h2 className="text-xl font-bold text-gray-900 mb-6">订阅信息</h2>
            {isLoading ? (
              <div className="animate-pulse">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                  {[...Array(4)].map((_, i) => (
                    <div key={i} className="bg-gray-50 rounded-xl p-4">
                      <div className="h-4 w-20 bg-gray-200 rounded mb-2"></div>
                      <div className="h-6 w-32 bg-gray-200 rounded"></div>
                    </div>
                  ))}
                </div>
                <div className="mt-6">
                  <div className="h-4 w-full bg-gray-200 rounded"></div>
                </div>
                <div className="mt-4 flex flex-wrap gap-4">
                  {[...Array(4)].map((_, i) => (
                    <div key={i} className="h-10 w-32 bg-gray-200 rounded-full"></div>
                  ))}
                </div>
              </div>
            ) : (
              userInfo.able === 1 ? (
                <div className="space-y-6">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                    <div className="bg-gray-50 rounded-xl p-4">
                      <div className="text-sm text-gray-500 mb-1">总流量</div>
                      <div className="text-xl font-semibold text-gray-900 break-all">{formatBytes(userInfo.traffic)}</div>
                    </div>
                    <div className="bg-gray-50 rounded-xl p-4">
                      <div className="text-sm text-gray-500 mb-1">已用流量</div>
                      <div className="text-xl font-semibold text-gray-900 break-all">{formatBytes(userInfo.trafficked)}</div>
                    </div>
                    <div className="bg-gray-50 rounded-xl p-4">
                      <div className="text-sm text-gray-500 mb-1">速率限制</div>
                      <div className="text-xl font-semibold text-gray-900">
                        {userInfo.plan === 0 && userInfo.traffic < 50 * 5368709120 ? "50Mbps" : (userInfo.plan.id !== 0 && userInfo.plan_detail.limit === 0 ? '不限速' : `${userInfo.plan_detail.limit}Mbps`)}
                      </div>
                    </div>
                    <div className="bg-gray-50 rounded-xl p-4">
                      <div className="text-sm text-gray-500 mb-1">到期时间</div>
                      <div className="text-xl font-semibold text-gray-900 break-all">{convertTimestamp(userInfo.expired)}</div>
                    </div>
                  </div>

                  {/* 自动续费开关 */}
                  <div className="mt-6 flex items-center justify-between bg-gray-50 rounded-xl p-4">
                    <div>
                      <div className="text-sm text-gray-500 mb-1">自动续费</div>
                      <div className="text-sm text-gray-600">开启后将在套餐到期时自动续费</div>
                    </div>
                    <Switch
                      onChange={handleAutoRenewChange}
                      checked={isAutoRenewEnabled}
                      onColor="#4F46E5"
                      offColor="#E5E7EB"
                      checkedIcon={false}
                      uncheckedIcon={false}
                      height={24}
                      width={48}
                    />
                  </div>

                  {/* 流量使用进度条 */}
                  <div className="mt-6">
                    <div className="flex justify-between text-sm text-gray-600 mb-2">
                      <span>剩余流量</span>
                      <span className="break-all text-right ml-2">{formatBytes(userInfo.traffic - userInfo.trafficked)}</span>
                    </div>
                    <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                      <div
                        className="h-full bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full transition-all duration-500"
                        style={{
                          width: `${Math.min(((userInfo.traffic - userInfo.trafficked) / userInfo.traffic) * 100, 100)}%`,
                        }}
                      />
                    </div>
                  </div>

                  {/* 操作按钮 */}
                  <div className="flex flex-col sm:flex-row flex-wrap gap-4 mt-6">
                    <label htmlFor="sub" className="btn bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-6 py-2 rounded-full hover:from-blue-600 hover:to-indigo-700 transition-all duration-300 w-full sm:w-auto text-center border-0">
                      订阅 [导入节点]
                    </label>
                    <label htmlFor="changeSub" className="btn bg-gray-100 text-gray-700 px-6 py-2 rounded-full hover:bg-gray-200 transition-all duration-300 w-full sm:w-auto text-center border-0">
                      修改订阅地址
                    </label>
                    {userInfo.plan !== 0 && (
                      <>
                        <label htmlFor="planDetail" className="btn bg-gray-100 text-gray-700 px-6 py-2 rounded-full hover:bg-gray-200 transition-all duration-300 w-full sm:w-auto text-center border-0">
                          查看套餐详情
                        </label>
                        <label htmlFor="rePlan" className="btn bg-gray-100 text-gray-700 px-6 py-2 rounded-full hover:bg-gray-200 transition-all duration-300 w-full sm:w-auto text-center border-0">
                          重置套餐
                        </label>
                      </>
                    )}
                    <button onClick={() => window.location.href = '/help'} className="btn bg-gray-100 text-gray-700 px-6 py-2 rounded-full hover:bg-gray-200 transition-all duration-300 w-full sm:w-auto text-center border-0">
                      查看使用教程
                    </button>
                  </div>
                </div>
              ) : (
                <div className="text-center py-8">
                  <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    {userInfo.trafficked >= userInfo.traffic ? "流量耗尽" :
                      userInfo.expired <= Date.now() && userInfo.expired !== 0 ? "套餐过期" : "套餐有效"}
                  </h3>
                  <p className="text-gray-600 mb-4 break-all">
                    {userInfo.trafficked >= userInfo.traffic ?
                      `已使用 ${formatBytes(userInfo.trafficked)} / ${formatBytes(userInfo.traffic)}` :
                      userInfo.expired <= Date.now() && userInfo.expired !== 0 ?
                        `到期时间：${convertTimestamp(userInfo.expired)}` :
                        `剩余流量：${formatBytes(userInfo.traffic - userInfo.trafficked)}`}
                  </p>
                  <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <a href="/plan" className="inline-flex items-center justify-center bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-8 py-3 rounded-full hover:from-blue-600 hover:to-indigo-700 transition-all duration-300 w-full sm:w-auto">
                      购买套餐
                    </a>
                    {userInfo.plan !== 0 && (
                      <>
                        <label htmlFor="rePlan" className="inline-flex items-center justify-center bg-gradient-to-r from-green-500 to-emerald-600 text-white px-8 py-3 rounded-full hover:from-green-600 hover:to-emerald-700 transition-all duration-300 w-full sm:w-auto cursor-pointer">
                          重置套餐
                        </label>
                        <label htmlFor="planDetail" className="inline-flex items-center justify-center bg-gray-100 text-gray-700 px-8 py-3 rounded-full hover:bg-gray-200 transition-all duration-300 w-full sm:w-auto cursor-pointer">
                          查看套餐详情
                        </label>
                      </>
                    )}
                  </div>
                </div>
              )
            )}
          </div>

          {/* 节点列表 */}
          <div className="bg-white rounded-2xl shadow-lg p-6 transform transition-all duration-300 hover:shadow-xl">
            <h2 className="text-xl font-bold text-gray-900 mb-6">可用节点</h2>
            {isLoading ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 animate-pulse">
                {[...Array(6)].map((_, i) => (
                  <div key={i} className="bg-gray-50 rounded-xl p-4">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-gray-200 rounded-lg"></div>
                        <div>
                          <div className="h-4 w-24 bg-gray-200 rounded"></div>
                          <div className="h-3 w-16 bg-gray-200 rounded mt-2"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {nodeList && nodeList
                  .sort((a, b) => a.rate - b.rate)
                  .map((node, index) => (
                    <div key={index} className="bg-gray-50 rounded-xl p-4 transform transition-all duration-300 hover:bg-gray-100">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-3">
                          <div className="p-2 bg-blue-100 rounded-lg">
                            <svg className="h-5 w-5 text-blue-600" fill="currentColor" viewBox="0 0 20 18">
                              <path d="M3.5 13a4.5 4.5 0 118.94-2.03A4 4 0 0114 18H4a3.5 3.5 0 01-.5-7z" />
                            </svg>
                          </div>
                          <div>
                            <div className="font-medium text-gray-900 break-all">{node.name.replace('中转', '')}</div>
                            <div className="text-sm text-gray-500">倍率: {node.rate}x</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* 点击其他区域关闭下拉菜单 */}
      <div
        className="fixed inset-0 z-[9998] hidden"
        id="menuOverlay"
        onClick={() => {
          const menu = document.getElementById('profileMenu');
          if (menu) {
            menu.classList.add('hidden');
          }
        }}
      />

      {/* 模态框组件 */}
      <ChangeEmail userInfo={userInfo} setUserInfo={setUserInfo} />
      <Sign userInfo={userInfo} setUserInfo={setUserInfo} getUserInfo={getUserInfo} />
      <Recom userInfo={userInfo} getUserInfo={getUserInfo} />
      <Passwd />
      <RegTips aff={userInfo.aff_rate} />
      <Recharge totalSpent={userInfo.total_spent} getUserInfo={getUserInfo} />
      <RePlan userInfo={userInfo} getUserInfo={getUserInfo} />
      <Sub subLink={subLink} />
      <ChangeSub getUserInfo={getUserInfo} />
      <PlanDetail userInfo={userInfo} />

      {/* 隐藏的checkbox用于控制弹窗 */}
      <input type="checkbox" id="profile" className="hidden" />

      {/* 修改资料弹窗 */}
      <div
        id="profileModal"
        className="fixed inset-0 flex items-center justify-center z-50 opacity-0 pointer-events-none transition-opacity duration-300"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
        onClick={(e) => {
          if (e.target.id === 'profileModal') {
            const modal = document.getElementById('profileModal');
            const modalContent = document.getElementById('profileModalContent');
            if (modal && modalContent) {
              modal.classList.add('opacity-0', 'pointer-events-none');
              modalContent.classList.add('scale-95', 'opacity-0');
              setTimeout(() => {
                modal.style.display = 'none';
              }, 300);
            }
          }
        }}
      >
        <div
          id="profileModalContent"
          className="bg-white rounded-2xl p-6 w-full max-w-md mx-4 transform scale-95 opacity-0 transition-all duration-300"
        >
          <h2 className="text-xl font-bold text-gray-900 mb-6">修改资料</h2>
          <Profile />
          <div className="mt-6 flex justify-end">
            <button
              onClick={() => {
                const modal = document.getElementById('profileModal');
                const modalContent = document.getElementById('profileModalContent');
                if (modal && modalContent) {
                  modal.classList.add('opacity-0', 'pointer-events-none');
                  modalContent.classList.add('scale-95', 'opacity-0');
                  setTimeout(() => {
                    modal.style.display = 'none';
                  }, 300);
                }
              }}
              className="px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors duration-300"
            >
              取消
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;